module.exports = __webpack_public_path__ + "media/site/images/products/saas_oeetools-screen3@2x-d53b4e8a8e956c2b581831dc3f1126c0.png";